import { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, UserRound, Download } from "lucide-react";
import { ASSETS } from "@/lib/assets";
import { BACKEND_URL } from "@/lib/api";

const links = [
  { to: "/", label: "HOME" },
  { to: "/layanan", label: "SERVICES" },
  { to: "/portofolio", label: "PORTFOLIO" },
  { to: "/klien", label: "CLIENTS" },
  { to: "/berita", label: "BERITA" },
  { to: "/karir", label: "KARIR" },
  { to: "/tentang", label: "ABOUT US" },
  { to: "/kontak", label: "CONTACT" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? "glass" : "bg-gradient-to-b from-black/70 to-transparent"}`} data-testid="navbar">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
            <img src={ASSETS.lotusLogo} alt="Lotus Lentera" className="w-10 h-10 lg:w-12 lg:h-12 object-contain drop-shadow-[0_0_12px_rgba(212,175,55,0.5)]" />
            <div className="leading-none">
              <div className="font-syne font-extrabold text-xl lg:text-2xl tracking-wide silver-gradient-text">LOTUS</div>
              <div className="font-syne font-bold text-[11px] lg:text-sm tracking-[0.4em] gold-gradient-text">LENTERA</div>
            </div>
          </Link>

          <nav className="hidden xl:flex items-center gap-7">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === "/"} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) => `text-[13px] font-semibold tracking-wide transition-colors relative pb-1 ${isActive ? "text-gold border-b-2 border-[#D4AF37]" : "text-white/80 hover:text-gold"}`}>
                {l.label}
              </NavLink>
            ))}
          </nav>

          <a href={`${BACKEND_URL}/api/company-profile.pdf`} target="_blank" rel="noreferrer"
            className="hidden xl:flex items-center gap-2.5 btn-gold pl-2 pr-5 py-2 rounded-full text-[12px] font-bold tracking-wide" data-testid="nav-download-profile">
            <span className="w-8 h-8 rounded-full bg-black/20 flex items-center justify-center"><UserRound className="w-4 h-4" /></span>
            DOWNLOAD COMPANY PROFILE
          </a>

          <button className="xl:hidden text-white p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="xl:hidden glass border-t border-amber-500/15" data-testid="nav-mobile-menu">
          <div className="px-4 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === "/"} onClick={() => setOpen(false)}
                className={({ isActive }) => `py-2.5 px-3 rounded-lg text-sm font-semibold tracking-wide ${isActive ? "text-gold bg-white/5" : "text-white/80"}`}>
                {l.label}
              </NavLink>
            ))}
            <a href={`${BACKEND_URL}/api/company-profile.pdf`} target="_blank" rel="noreferrer" className="btn-gold mt-2 py-2.5 rounded-full text-sm text-center flex items-center justify-center gap-2"><Download className="w-4 h-4" /> Download Company Profile</a>
          </div>
        </div>
      )}
    </header>
  );
};
